import api, { ApiResponse, formatApiError } from './api'

export const uploadFiles = async (
  data: FormData
): Promise<ApiResponse<UploadFilesResponse>> => {
  try {
    const response = await api.post(`/auth/guest/upload`, data)
    return {
      error: false,
      body: response.data.body
    }
  } catch (error: unknown) {
    return formatApiError(error)
  }
}

export type UploadFilesResponse = {
  name?: string
  url: string
}[]

export const uploadMultipleFiles = async (
  files: File[]
): Promise<ApiResponse<UploadFilesResponse>> => {
  const formData = new FormData()

  files.forEach(file => {
    if (typeof file === 'string') {
      return
    }

    if (!file) {
      return
    }

    formData.append('file', file)
  })

  return await uploadFiles(formData)
}
